export interface ParsedEmbedProps {
  wrapperId?: string;
  aspectRatio?: string;
  mobileAspectRatio?: string;
  iframeClass?: string;
  iframeSrc: string;
  scriptSrc?: string;
  scriptDomain?: string;
  frameBorder?: string;
  scrolling?: string;
  allowFullScreen?: boolean;
  title?: string;
}

export function parseEmbeddedCode(html: string): ParsedEmbedProps | null {
  if (!html) return null;

  // Extract from <div>
  const divIdMatch = html.match(/<div[^>]*id=["']([^"']+)["']/i);
  const aspectRatioMatch = html.match(/data-aspectratio=["']([^"']+)["']/i);
  const mobileAspectRatioMatch = html.match(/data-mobile-aspectratio=["']([^"']+)["']/i);

  // Extract from <iframe>
  const iframeSrcMatch = html.match(/<iframe[^>]*src=["']([^"']+)["']/i);
  if (!iframeSrcMatch) return null;

  const iframeClassMatch = html.match(/<iframe[^>]*class=["']([^"']+)["']/i);
  const frameBorderMatch = html.match(/<iframe[^>]*frameborder=["']([^"']+)["']/i);
  const scrollingMatch = html.match(/<iframe[^>]*scrolling=["']([^"']+)["']/i);
  const allowFullScreenMatch = html.match(/<iframe[^>]*allowfullscreen(?:=["']?[^"']*["']?)?/i);
  const titleMatch = html.match(/<iframe[^>]*title=["']([^"']+)["']/i);

  // Extract from <script>
  const scriptSrcMatch = html.match(/<script[^>]*src=["']([^"']+)["']/i);

  let scriptDomain: string | undefined;
  if (scriptSrcMatch?.[1]) {
    try {
      const url = new URL(scriptSrcMatch[1]);
      scriptDomain = url.hostname;
    } catch {
      console.error('Invalid scriptSrc URL:', scriptSrcMatch[1]);
    }
  }

  return {
    allowFullScreen: !!allowFullScreenMatch,
    aspectRatio: aspectRatioMatch?.[1],
    frameBorder: frameBorderMatch?.[1],
    iframeClass: iframeClassMatch?.[1],
    iframeSrc: iframeSrcMatch[1],
    mobileAspectRatio: mobileAspectRatioMatch?.[1],
    scriptDomain,
    scriptSrc: scriptSrcMatch?.[1],
    scrolling: scrollingMatch?.[1],
    title: titleMatch?.[1],
    wrapperId: divIdMatch?.[1],
  };
}
